import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { message, Spin } from 'antd';
import axiosInstance from '../axiosInstance';

const ProtectedRoute = ({ children }) => {
  const [authState, setAuthState] = useState({
    loading: true,
    isValid: false
  });

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const token = localStorage.getItem('token');
        if (!token) {
          throw new Error('No token found');
        }

        // This will now properly fail if token is invalid
        const response = await axiosInstance.get('/check-package-limit');
        
        // Additional check for actual response data
        if (!response.data || !response.data.message) {
          throw new Error('Invalid response');
        }

        setAuthState({ loading: false, isValid: true });
      } catch (err) {
        console.error('Auth check failed:', err);
        
        // Clear all auth-related data
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        localStorage.removeItem('shopId');
        localStorage.removeItem('employeeId');
        
        setAuthState({ loading: false, isValid: false });
        
        // Show error message only if not already on login page
        if (!window.location.pathname.includes('/login')) {
          message.error('Session expired. Please log in again.');
        }
      }
    };

    checkAuth();
  }, []);

  if (authState.loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <Spin tip="Checking session..." size="large" />
      </div>
    );
  }

  if (!authState.isValid) {
    return <Navigate to="/login" replace state={{ from: 'protected-route' }} />;
  }

  if (!authState.isValid) {
    return <Navigate to="/login" replace state={{ from: 'protected-route' }} />;
  }
  
  return children;
};

export default ProtectedRoute;